<template>
    <section>
        <b-modal 
            id='uploader-modal'
            hide-footer
            title='Прикрепить фотографии документов'
        >
            <multiselect 
                v-if='docTypes'
                class='mb-3'
                @select='selectDocType'
                @remove='setDocType(null)'
                v-model="_selectedDocType" 
                :options="docTypes" 
                :searchable="true" 
                :close-on-select="true" 
                :show-labels="false" 
                placeholder="Тип документа"
                label="doc_name" 
                track-by="doc_name"
            ></multiselect>

            <file-pond
                v-if='_selectedDocType'
                ref="pond"
                name='imgUploader'
                :server="{ process }" 
                label-idle="Нажми, перетяни или скопируй..."
                allow-multiple="false"
                allow-metadata='true'
                instant-upload="false"
                allowImageResize='true'
                :imageTransformOutputQuality='60'
                :imageResizeTargetWidth='1280'
                :imageResizeTargetHeight='720'
                imageResizeMode='contain'
                :files="myFiles"
            />
        </b-modal>
    </section>
</template>


<script>
import { mapState, mapActions } from 'vuex';

import Multiselect from 'vue-multiselect'

import vueFilePond, { setOptions } from 'vue-filepond';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css';

const FilePond = vueFilePond(
  FilePondPluginFileValidateType, 
  FilePondPluginImagePreview, 
  FilePondPluginFileRename, 
  FilePondPluginImageCrop,
  FilePondPluginImageTransform,
  FilePondPluginImageResize,
  FilePondPluginImageExifOrientation,
  FilePondPluginImageEdit,
  FilePondPluginFileMetadata
);
export default {
    name: 'uploader',
    components: { FilePond, Multiselect },
    data() {
        return {
            myFiles: [],
            uploadedFiles: [],
            selectedDocType: null,
        }
    },
    methods: {
        ...mapActions('covid', ['setDocType']),

        process(fieldName, file, metadata, load, error, progress, abort) {
            var self = this;
            let params = JSON.stringify({
                Name_app: "WEB_division",
                id_login: this.userData.id_login,
                id_patient: this.id_patient,
                id_doc_type: this._selectedDocType.id_doc_type
            })
            const formData = new FormData();
            formData.append(fieldName, file, file.name);
            formData.append('submit', 'upload')
            formData.append('json', `${params}`)
            const request = new XMLHttpRequest();
            request.open('POST', `https://host1.medsafe.tech:50443/api/Upload/`);
            request.upload.onprogress = (e) => {
                progress(e.lengthComputable, e.loaded, e.total);
            };
            request.onload = function() {
                if (request.status >= 200 && request.status < 300) {
                    if (request.responseText.includes("File uploaded sucessfully!")) {
                        self.$bvToast.toast(`Файл сохранен`, {
                            title: 'Успешно!',
                            variant: 'success',
                            solid: true
                        })
                    } else self.$bvToast.toast(`Файл не сохранен`, {
                            title: 'Что-то пошло не так...',
                            variant: 'danger',
                            solid: true
                        })
                    load(request.responseText);
                    self.$refs.pond.removeFiles()
                    self.setDocType(null)
                }
                else {
                    error('oh no');
                }
            };
            request.send(formData);
                return {
                abort: () => {
                    request.abort();
                    abort();
                }
            };
        },
        handleProcessFile(error, file) {
            file => new Promise(resolve => {
                resolve(window.prompt('Укажите имя файла', file.name))
            })
            this.uploadFile(file.file)
            this.uploadedFiles.push(file.filename);
        },
        handleRemoveFile(file) {
            var index = this.myFiles.indexOf(file.filename);
            if (index > -1) {
                this.uploadedFiles.splice(index, 1);
                this.$nextTick();
            }
        },
        selectDocType(item) {
            this.setDocType(item)
        },
    },
    computed: {
        ...mapState({
            userData: state => state.userData,
            id_patient: state => state.covid.selectedPatient.id_patient,
            doc_type: state => state.covid.doc_type,
            docTypes: state => state.covid.docTypes,
        }),
        _selectedDocType: {
            get() { return this.doc_type },
            set(value) { this.setDocType(value) }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/Uploader.vue